import React from 'react';
import PropTypes from 'prop-types';

import UriSorting from 'utils/UriSorting';

const withSorting = (defaultSort={}) => (WrappedComponent) => {
  const SortedComponent = (props) => {
    const { location } = props;
    const uriSorting = new UriSorting(location);

    const sort = uriSorting.getSort(defaultSort); // Object like {"column": "field_name", "order": "ASC"}
    const sortString = uriSorting.getSortAsString();  // String like "field_name ASC"
    const sortJson = JSON.stringify(sort || {}); // Object like {"column": "field_name", "order": "ASC"}, but stringified

    const onSort = (columnName, direction) => uriSorting.sortLink({
      column: columnName,
      order: direction
    });

    return <WrappedComponent {...props} sort={sort} onSort={onSort} sortString={sortString} sortJson={sortJson}/>;
  };

  SortedComponent.propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string
    }).isRequired
  };

  return SortedComponent;
};

withSorting.propTypes = {
  WrappedComponent: PropTypes.element
};

export default withSorting;
